export enum TidbitCollectionTags {
  GET_TIDBIT_COLLECTIONS,
  GET_TIDBIT_COLLECTION,
}

export enum ByteTags {
  GET_BYTES,
  GET_BYTE,
}

export enum ClickableDemoTags {
  GET_CLICKABLE_DEMOS,
  GET_CLICKABLE_DEMO,
}

export enum SpaceTags {
  GET_SPACE,
  GET_SPACE_BY_ID,
}
